import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
    token :string = 'Bearer 77dbd34503d267f188c1156b8cac5890';
    instaToken :string = '364399493.1677ed0.7108187dd72948dc80274f4d46ca707c';
    apiKey: "AIzaSyCZ6srunC4Xu9NeOVf4sdUdGIoggLQabek";
    authDomain: "mark-climb.firebaseapp.com";
    databaseURL: "https://mark-climb.firebaseio.com";
    projectId: "mark-climb";
    storageBucket: "mark-climb.appspot.com";
    messagingSenderId: "512982081956";
}


// WEBPACK FOOTER //
// /Users/mdg/Source/markclimb/globals.ts